//Blender资源管理相关请求
import { request } from '@/utils';

export function uploadBlenderResourceAPI(data) {
    let resourceName = data.get('resourceName');
    let aircraftSortie = data.get('aircraftSortie');
    let description = data.get('description');
    let file = data.get('file');
    return request({
        url: '/api/design-resource/create',
        method: 'POST',
        data: {
            resourceName,
            aircraftSortie,
            description,
            file
        },
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    });
}

export function getBlenderResourceListAPI() {
    return request({
        url: '/api/design-resource/list',
        method: 'GET',
    });
}